<script>
import VModule from "@/components/organisms/VModule.vue";

export default {
  name: "Home",
  components: {
    VModule
  },
  computed: {
    data() {
      return this.$store.state.appData.siteMain;
    }
  }
};
</script>

<template>
  <div>
    <VModule
      v-for="(component, index) in data.components"
      :key="index"
      :data="component"
      :index="index"
    />
  </div>
</template>
